"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.read = exports.write = void 0;
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveObjectsData_sidecar_1 = require("@dive/entities/diveObjectsData-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveStringSaver_sidecar_1 = require("./diveStringSaver-sidecar");
var version = 'v0.1.5';
var namespace = 'objects';
function write() {
    var e_1, _a;
    diveStringSaver_sidecar_1.diveStringSaver.wHeader(namespace, version);
    var objs = diveObjects_sidecar_1.diveObjects.getAll();
    try {
        for (var objs_1 = __values(objs), objs_1_1 = objs_1.next(); !objs_1_1.done; objs_1_1 = objs_1.next()) {
            var c = objs_1_1.value;
            if (c.isDead) {
                continue;
            }
            diveStringSaver_sidecar_1.diveStringSaver.wString('object');
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.id);
            diveStringSaver_sidecar_1.diveStringSaver.wString(c.data.type);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.i);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.j);
            diveStringSaver_sidecar_1.diveStringSaver.wBool(c.isOpen);
            diveStringSaver_sidecar_1.diveStringSaver.wBool(c.isAwake);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.ticksAwake);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (objs_1_1 && !objs_1_1.done && (_a = objs_1.return)) _a.call(objs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    diveStringSaver_sidecar_1.diveStringSaver.wEnd(namespace);
}
exports.write = write;
function read() {
    diveStringSaver_sidecar_1.diveStringSaver.rHeader(namespace, version);
    diveObjects_sidecar_1.diveObjects.killAll();
    while (diveStringSaver_sidecar_1.diveStringSaver.rPeek('object')) {
        diveStringSaver_sidecar_1.diveStringSaver.rString('object');
        var id = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var type = diveStringSaver_sidecar_1.diveStringSaver.rString();
        var i = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var j = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var isOpen = diveStringSaver_sidecar_1.diveStringSaver.rBool();
        var isAwake = diveStringSaver_sidecar_1.diveStringSaver.rBool();
        var ticksAwake = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var data = diveObjectsData_sidecar_1.diveObjectsData.get(type);
        assert_sidecar_1.assert.notNil(data);
        var c = diveObjects_sidecar_1.diveObjects.create(id, data);
        c.isOpen = isOpen;
        c.isAwake = isAwake;
        c.ticksAwake = ticksAwake;
        diveObjects_sidecar_1.diveObjects.moveToIJ(c, i, j);
    }
    diveStringSaver_sidecar_1.diveStringSaver.rEnd(namespace);
}
exports.read = read;
